var _rect, _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKaraca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 124,
    viewBox: "0 0 248 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 124,
    fill: "white",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_963)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_963",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 39,
    width: 200,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 39.2727H24V84.7272H224V39.2727Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_963)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_302_963",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 39,
    width: 200,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224 39.2727H24V84.7272H224V39.2727Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_302_963)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_302_963",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 40,
    width: 200,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224 40.7878H24V84.7272H224V40.7878Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_302_963)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_302_963",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 40,
    width: 200,
    height: 45
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224 40.7878H24V84.7272H224V40.7878Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_302_963)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_302_963",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 40,
    width: 200,
    height: 45
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224 40.7878H24V84.7272H224V40.7878Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_302_963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.181 84.0238L77.7843 73.5124V84.0953H72.8262V61.1628H77.7843V71.3072L86.7376 61.2363H92.805L82.6674 72.4131L93.1726 84.0972H87.181V84.0238Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.631 61.1633V84.0242H111.673V80.7141C109.815 83.2745 106.787 84.7377 103.612 84.6097C97.3217 84.6097 92.142 79.3173 92.142 72.5547C92.142 65.7188 97.3246 60.4998 103.612 60.4998C106.765 60.3945 109.773 61.8204 111.673 64.322V61.09H116.631V61.1633ZM111.673 72.631C111.633 68.6526 108.353 65.4603 104.348 65.5007C100.343 65.5413 97.13 68.7994 97.1707 72.7779C97.2113 76.7274 100.446 79.9082 104.422 79.9083C108.317 80.0192 111.565 76.9721 111.677 73.1024C111.681 72.9453 111.68 72.788 111.673 72.631Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.355 60.7952V66.1609C130.099 65.9408 126.253 67.4109 126.253 72.5565V84.0927H121.294V61.1632H126.252V64.9855C127.584 61.8983 130.395 60.7952 133.355 60.7952Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.105 61.1641V84.0297H154.148V80.7214C152.289 83.282 149.261 84.7451 146.086 84.617C139.869 84.6132 134.687 79.3942 134.687 72.6307C134.687 65.7948 139.869 60.5757 146.156 60.5757C149.31 60.4706 152.318 61.8965 154.218 64.398V61.1641H159.105ZM154.148 72.6317C154.107 68.6533 150.828 65.4609 146.823 65.5015C142.817 65.5421 139.604 68.8001 139.645 72.7785C139.685 76.7282 142.92 79.9089 146.896 79.9091C150.791 80.0194 154.038 76.9718 154.15 73.1023C154.154 72.9451 154.154 72.7888 154.148 72.6317Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.435 72.6307C162.287 66.1204 167.479 60.7233 174.033 60.5757C174.211 60.5718 174.391 60.5718 174.571 60.5757C178.833 60.4843 182.795 62.7493 184.856 66.4565L180.564 68.9553C179.429 66.7189 177.089 65.3418 174.571 65.4277C170.566 65.4924 167.372 68.7703 167.436 72.7489C167.5 76.6363 170.658 79.7724 174.571 79.8357C177.124 79.9043 179.499 78.5404 180.713 76.308L185.005 78.7334C182.929 82.4728 178.942 84.7646 174.646 84.6875C168.008 84.7921 162.542 79.5316 162.437 72.9378C162.435 72.8356 162.435 72.7331 162.435 72.6307Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.346 61.1633V84.0242H206.388V80.7141C204.53 83.2745 201.501 84.7377 198.327 84.6097C192.037 84.6097 186.856 79.3173 186.856 72.5547C186.856 65.7188 192.039 60.4998 198.327 60.4998C201.48 60.3945 204.487 61.8204 206.388 64.322V61.09H211.346V61.1633ZM206.388 72.631C206.348 68.6526 203.068 65.4603 199.064 65.5007C195.059 65.5413 191.845 68.7994 191.886 72.7779C191.926 76.7274 195.161 79.9082 199.137 79.9083C203.032 80.0186 206.28 76.971 206.391 73.1015C206.395 72.9447 206.394 72.7877 206.388 72.631Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.305 65.0592C216.305 62.9483 218.027 61.2371 220.151 61.2371C222.277 61.2371 223.999 62.9483 223.999 65.0592C223.999 67.1702 222.277 68.8815 220.151 68.8815C218.042 68.8957 216.318 67.2075 216.305 65.1108C216.305 65.0937 216.305 65.0765 216.305 65.0592ZM223.186 65.0592C223.229 63.438 221.942 62.0887 220.31 62.0455C220.256 62.0442 220.205 62.0442 220.151 62.0455C218.495 62.0275 217.136 63.3477 217.118 64.994C217.118 65.0157 217.118 65.0375 217.118 65.0592C217.075 66.6804 218.362 68.0298 219.994 68.073C220.048 68.0743 220.099 68.0743 220.151 68.073C221.809 68.091 223.168 66.7708 223.186 65.1245C223.186 65.1027 223.186 65.081 223.186 65.0592Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.301 65.6477H219.634V67.1179H218.82V62.8542H220.522C221.298 62.8538 221.926 63.4782 221.928 64.2491V64.2511C221.899 64.7818 221.589 65.2579 221.113 65.5009L222.073 67.1218H221.185L220.301 65.6477ZM219.634 64.9127H220.522C220.889 64.8646 221.149 64.5292 221.1 64.1638C221.06 63.8644 220.824 63.6288 220.522 63.5894H219.634V64.9127Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6656 48.5794V40.9015H54.5598V48.5794H49.4541V40.9015H44.3463V48.5794H41.685C40.332 48.5581 39.2459 47.4638 39.2435 46.1196V40.8271H34.1376V46.3428C34.1164 50.3465 37.3591 53.6131 41.3894 53.6478H54.4858V58.942C54.4834 60.2862 53.3973 61.3805 52.0443 61.4018H31.5473C30.1943 61.3805 29.1082 60.2862 29.1058 58.942V58.8658H24V59.2385C23.9998 60.9871 24.6296 62.6782 25.7755 64.0056C24.6181 65.3262 23.9866 67.0217 24 68.7726V84.5812H29.1058V74.2205C29.0846 72.8421 30.1922 71.7076 31.5797 71.6865C31.5935 71.6864 31.6074 71.6862 31.6211 71.6862C33.0089 71.6846 34.1353 72.8006 34.137 74.1791C34.137 74.1929 34.137 74.2067 34.1367 74.2205V84.5068H39.2424V74.2205C39.2212 72.8421 40.3288 71.7076 41.7164 71.6865C41.7292 71.6864 41.7422 71.6862 41.755 71.6862C43.1426 71.6846 44.269 72.8006 44.2708 74.1791C44.2708 74.1929 44.2707 74.2067 44.2705 74.2205V84.5068H49.3763V74.2205C49.3551 72.8421 50.4627 71.7076 51.8501 71.6865C51.864 71.6864 51.8779 71.6862 51.8918 71.6862C53.2794 71.6846 54.4058 72.8006 54.4074 74.1791C54.4074 74.1929 54.4074 74.2067 54.4071 74.2205V84.5068H59.513V66.5426V61.3999V56.1076C59.5155 54.7634 60.6016 53.6691 61.9546 53.6478H64.6926V48.505H59.6656V48.5794Z",
    fill: "#231F20"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 45.4545,
    fill: "white",
    transform: "translate(24 39.2727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaraca);
export default __webpack_public_path__ + "static/media/karaca.fe8f23ab957a1a76d47d398629c6de69.svg";
export { ForwardRef as ReactComponent };